module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/utensils.svg?a3b588aaa6689dfdd2a2c8343ba60658";